module.exports = __webpack_public_path__ + "media/application/images/icons/dropdown-ca3a7d1197843b4e1e309fe7e36cd40e.svg";